import { HttpErrorResponse, HttpInterceptorFn } from "@angular/common/http"
import { inject } from "@angular/core"
import { MatSnackBar } from "@angular/material/snack-bar"
import { catchError, throwError } from "rxjs"

function extractMessage(err: HttpErrorResponse): string {
  const body = err.error
  if (body) {
    if (typeof body.detail === "string") return body.detail
    if (Array.isArray(body.detail)) {
      return body.detail.map((d: { msg?: string }) => d.msg ?? String(d)).join("; ")
    }
    if (typeof body.message === "string") return body.message
  }
  return err.message || `Request failed (${err.status})`
}

export const errorNotificationInterceptor: HttpInterceptorFn = (req, next) => {
  const snackBar = inject(MatSnackBar)

  return next(req).pipe(
    catchError((err: unknown) => {
      if (err instanceof HttpErrorResponse && err.status !== 401) {
        snackBar.open(extractMessage(err), "Dismiss", { duration: 5000 })
      }
      return throwError(() => err)
    }),
  )
}
